import PropTypes from "prop-types";
import "./ImgBtn.css";

export default function ImgBtn({
	// img
	className,
	image,
	alt,
	citation,
	// radio btn
	label,
	value,
	name,
	checked,
	onChange,
}) {
	return (
		<label className="img-btn">
			{/* Img ----------------------------------------------------------------------- */}
			<div className="img-btn-img-container">
				<img
					className={className}
					src={image}
					alt={alt}
					aria-hidden="true"
					data-citation={citation}
				/>
			</div>

			{/* Radio btn ----------------------------------------------------------------- */}
			<div className="img-btn-label">
				{label}
				<input
					type="radio"
					value={value}
					name={name}
					checked={checked}
					onChange={onChange}
				/>
			</div>
		</label>
	);
}

ImgBtn.propTypes = {
	// img
	className: PropTypes.string,
	image: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	citation: PropTypes.string.isRequired,
	// radio btn
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
};
